import { atom } from 'recoil';
import { IhomepageSetting } from '@typings/setting/homepageSetting.interface';
import { ImainHome } from '@typings/setting/mainHome.interface';
import { IstoreCommon } from '@typings/store/storeCommon.interface';
import { IbackgroundEffect } from '@typings/setting/backgroundEffect.interface';
import { IphotocardCharList } from '@typings/photocard/photocard.interface';

// 홈페이지 설정을 위한 전역 상태
export const homeSettingState = atom<IhomepageSetting | null>({
  key: 'homeSettingState',
  default: null,
});

// 홈페이지 설정 로딩 상태
export const homeSettingLoadingState = atom<boolean>({
  key: 'homeSettingLoadingState',
  default: true,
});

// 메인홈 설정을 위한 전역 상태
export const mainHomeSettingState = atom<ImainHome | null>({
  key: 'mainHomeSettingState',
  default: null,
});

// 기본 통화 설정을 위한 전역 상태
export const defaultCurrencyState = atom<IstoreCommon>({
  key: 'defaultCurrencyState',
  default: {
    moneyUnit: '골드',
    moneyImgURL: 'G',
    logoImgURL: '',
  },
});

export const bgEffSetState = atom<IbackgroundEffect | null>({
  key: 'bgEffSetState',
  default: null,
});

// 대표 포토카드 전역 상태 (홈 설정과 동기)
export type RepresentativePhotocardRef = { id: string; collectionPath: string } | null;
export const representativePhotocardRefState = atom<RepresentativePhotocardRef>({
  key: 'representativePhotocardRefState',
  default: null,
});

// 스탠딩 캐릭터 전역 상태
export const standingCharacterState = atom<IphotocardCharList | null>({
  key: 'standingCharacterState',
  default: null,
});